import React from 'react';

const FAQIcon = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="75"
      height="75"
      x="0"
      y="0"
      viewBox="0 0 512 512"
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <path
            d="m476 120h-100v-60a28.031 28.031 0 0 0 -28-28h-312a28.031 28.031 0 0 0 -28 28v216a28.031 28.031 0 0 0 28 28h20v72a8 8 0 0 0 13.66 5.66l66.34-66.35v48.69a28.031 28.031 0 0 0 28 28h200.69l77.65 77.66a8 8 0 0 0 13.66-5.66v-72h20a28.031 28.031 0 0 0 28-28v-216a28.031 28.031 0 0 0 -28-28zm-332 168a8.008 8.008 0 0 0 -5.66 2.34l-66.34 66.35v-60.69a8 8 0 0 0 -8-8h-28a12.01 12.01 0 0 1 -12-12v-216a12.01 12.01 0 0 1 12-12h312a12.01 12.01 0 0 1 12 12v216a12.01 12.01 0 0 1 -12 12zm344 76a12.01 12.01 0 0 1 -12 12h-28a8 8 0 0 0 -8 8v60.69l-66.34-66.35a8.008 8.008 0 0 0 -5.66-2.34h-204a12.01 12.01 0 0 1 -12-12v-60h196a28.031 28.031 0 0 0 28-28v-140h100a12.01 12.01 0 0 1 12 12z"
            fill="#5c48d3"
          />
          <path
            d="m136 152a8 8 0 0 0 8-8 48 48 0 1 1 48 48 8 8 0 0 0 -8 8v24a8 8 0 0 0 16 0v-16.5a64 64 0 1 0 -72-63.5 8 8 0 0 0 8 8z"
            fill="#5c48d3"
          />
          <path d="m192 240a8 8 0 0 0 -8 8v8a8 8 0 0 0 16 0v-8a8 8 0 0 0 -8-8z" fill="#5c48d3" />
        </g>
      </g>
    </svg>
  );
};
export default FAQIcon;
